import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
export const TicketPortalTabArray = [
    {
        title: "All",
        eventKey: "all",
        value: "all",
    },
    {
        title: "In Progress",
        eventKey: "inprogress",
        value: "inprogress",
    },
    {
        title: "Open",
        eventKey: "open",
        value: "open",
    },
    {
        title: "Closed",
        eventKey: "closed",
        value: "closed",
    },
];
export const Ticketinfo = [
    {
        ticketId: "607762",
        status: "OPEN",
        desc: "Incorrect P&L display in Holdings report. This should have increased my profit by 2.4L. But it’s not showing the same. Lorem ipsum dolor    volutpat. Vulputate facilisis facilisis id aliquam. Volutpat massa  mi pharetra volutpat. Sit vitae metus urna nisl sed mauris pellentesque. Accumsan dui risus eget volutpat diam. Lorem ac sed",
        ticketDate: "05 Jun, 2023 3:18:42 AM",
    },
    {
        ticketId: "607762",
        status: "OPEN",
        desc: "Incorrect P&L display in Holdings report. This should have increased my profit by 2.4L. But it’s not showing the same. Lorem ipsum dolor    volutpat. Vulputate facilisis facilisis id aliquam. Volutpat massa  mi pharetra volutpat. Sit vitae metus urna nisl sed mauris pellentesque. Accumsan dui risus eget volutpat diam. Lorem ac sed",
        ticketDate: "05 Jun, 2023 3:18:42 AM",
    },
    {
        ticketId: "607762",
        status: "CLOSED",
        desc: "Incorrect P&L display in Holdings report. This should have increased my profit by 2.4L. But it’s not showing the same. Lorem ipsum dolor    volutpat. Vulputate facilisis facilisis id aliquam. Volutpat massa  mi pharetra volutpat. Sit vitae metus urna nisl sed mauris pellentesque. Accumsan dui risus eget volutpat diam. Lorem ac sed",
        ticketDate: "05 Jun, 2023 3:18:42 AM",
    },
    {
        ticketId: "607762",
        status: "IN PROGRESS",
        desc: "Incorrect P&L display in Holdings report. This should have increased my profit by 2.4L. But it’s not showing the same. Lorem ipsum dolor    volutpat. Vulputate facilisis facilisis id aliquam. Volutpat massa  mi pharetra volutpat. Sit vitae metus urna nisl sed mauris pellentesque. Accumsan dui risus eget volutpat diam. Lorem ac sed",
        ticketDate: "05 Jun, 2023 3:18:42 AM",
    },
    {
        ticketId: "607762",
        status: "IN PROGRESS",
        desc: "Incorrect P&L display in Holdings report. This should have increased my profit by 2.4L. But it’s not showing the same. Lorem ipsum dolor    volutpat. Vulputate facilisis facilisis id aliquam. Volutpat massa  mi pharetra volutpat. Sit vitae metus urna nisl sed mauris pellentesque. Accumsan dui risus eget volutpat diam. Lorem ac sed",
        ticketDate: "05 Jun, 2023 3:18:42 AM",
    },
    {
        ticketId: "607762",
        status: "CLOSED",
        desc: "Incorrect P&L display in Holdings report. This should have increased my profit by 2.4L. But it’s not showing the same. Lorem ipsum dolor    volutpat. Vulputate facilisis facilisis id aliquam. Volutpat massa  mi pharetra volutpat. Sit vitae metus urna nisl sed mauris pellentesque. Accumsan dui risus eget volutpat diam. Lorem ac sed",
        ticketDate: "05 Jun, 2023 3:18:42 AM",
    },
];
const reportimg = (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "edel-icon-Reports" })));
const fileimg = (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "edel-icon-file" })));
export const AttacchedData = [
    {
        contentimg: reportimg,
        name: "Holdings_Report_min_2Jun",
        size: "1 mb",
        format: "PDF",
    },
    {
        contentimg: fileimg,
        name: "Screenshot_10563402052023",
        size: "1 mb",
        format: "PDF",
    },
    {
        contentimg: fileimg,
        name: "PnL_Report",
        size: "1 mb",
        format: "PDF",
    },
];
export const errormsgDescError = (React.createElement("span", { className: "DMSan_14_500" },
    "Click on",
    " ",
    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "small-edbutton ps-1 pe-1", value: "New Ticket" }),
    " ",
    "to create one"));
export const TicketPortalIssue = [
    { title: "Select Issue", value: "SelectIssue" },
    { title: "Account Closure", value: "AccountClosure" },
    { title: "Address Modification", value: "AddressModification" },
    { title: "Bank Modification", value: "BankModification" },
    { title: "DDPI", value: "BankModification" },
    { title: "DP Scheme Change", value: "BankModification" },
    { title: "FATCA Update", value: "BankModification" },
    { title: "Income Tax Declaration ", value: "BankModification" },
    { title: "Mobile/email Modification", value: "BankModification" },
    { title: "NRML-SMTF funds Movement Preference", value: "BankModification" },
    { title: "New DIS Booklet", value: "NewDISBooklet" },
    { title: "Nomination", value: "Nomination" },
    { title: "Segment Activation", value: "SegmentActivation" },
    { title: "My issue is not listed here", value: "Myissue" },
];
export const fileuploadContent = [
    React.createElement(React.Fragment, null,
        React.createElement("span", { className: "DMSan_14_500 txt-midnight-blue" },
            "Drag & drop or",
            " ",
            React.createElement("a", { className: "txt-tomato text-decoration-underline cursorOnHover pe-1" }, "click here"),
            "to upload")),
];
export const fileuploadContentmb = [
    React.createElement(React.Fragment, null,
        React.createElement("span", { className: "DMSan_14_500 txt-midnight-blue" },
            React.createElement("a", { className: "txt-tomato text-decoration-underline cursorOnHover pe-1" }, "Tap here"),
            "to upload attachments")),
];
